import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export class UpdateLicenseApp extends React.Component<AppBaseProps, any> {
    private _uploadInputRef = null;
    private _uploadRef: kendo.ui.Upload = null;
    private _contentRef = null;
    private _licFile = null;
    common = new AppHelper();
    setTabTitle = true;
    translations: StringKeyDictionary<string> = null;
    uploadEnabled = false;
    uploadOptions: kendo.ui.UploadOptions = null;


    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    private _doOnSelect = (kendoEvent: kendo.ui.UploadSelectEvent) => {
        const file = kendoEvent.files[0];
        const validUpload = Helper.hasValue(file) && file.extension.toLowerCase() === ".lic";

        if (validUpload) {
            this.uploadEnabled = true;
            this._licFile = file;
        } else {
            this._licFile = null;
            this.uploadEnabled = false;
            NotificationHelper.showWarningMessage(this.translations["WebSMS.LicenseUpdate.LoadValidFile"]);
            kendoEvent.files.pop();
            kendoEvent.preventDefault();
            $(".k-upload-action.k-button.k-button-bare", this._contentRef).trigger("click");
        }
        this.setState({});
    }


    renderUpload = () => {
        return (
            <div style={{ maxWidth: 400 }} ref={r => this._contentRef = r}>
                <input name='licenseUpload' type='file' ref={r => this._uploadInputRef = r} />
            </div>
        );
    }

    upload = () => {
        if (this._licFile !== null) {
            const formData = new FormData();
            formData.append("license", this._licFile.rawFile);
            HTTPService.post<JsonResultClass>("UpdateLicense/Upload", formData)
                .then(result => {
                    if (result.Code === 1) {
                        NotificationHelper.showErrorMessage(result.Message);
                    } else {
                        Helper.setBusyIndicator(true).then(_ => {
                            window.location.href = Config.baseUrl;
                        });
                    }
                });
        }
    }

    componentDidMount() {
        this.uploadOptions.select = this._doOnSelect;
        this.uploadOptions.remove = () => {
            this.uploadEnabled = false;
            this._licFile = null;
            this.setState({});
        }
        this._uploadRef = $(this._uploadInputRef).kendoUpload(this.uploadOptions).data("kendoUpload");
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}